import { render, staticRenderFns } from "./Comp51t2.vue?vue&type=template&id=54daa5d9&scoped=true&"
import script from "./Comp51t2.vue?vue&type=script&lang=js&"
export * from "./Comp51t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp51t2.vue?vue&type=style&index=0&id=54daa5d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54daa5d9",
  null
  
)

export default component.exports